import { useDataLayer } from '@/hooks/useDataLayer';
import { useInViewChange } from '@/hooks/useInViewChange';
import type { Ga4Promotion } from '@/types';
import { type RefObject, useCallback } from 'react';

export const useTrackPromotion = (
  ref: RefObject<Element | null>,
  promotions: Ga4Promotion[],
) => {
  const { viewPromotion, selectPromotion } = useDataLayer();

  useInViewChange(ref, () => viewPromotion(promotions), {
    disabled: promotions.length === 0,
  });

  const onSelect = useCallback(
    (promotion: Ga4Promotion) => selectPromotion(promotion),
    [selectPromotion],
  );

  return { onSelect };
};